import { roundToPrecision } from "../../helpers/math"

export type NumericType = 'cents' | 'percentage'

export const getNumericValue = (defaultValue: number, currentValue?: number, type?: NumericType): number => {
  const value = currentValue ?? defaultValue
  switch (type) {
    case 'cents': return value / 100
    case 'percentage' : return roundToPrecision(value * 100, 2)
    default: return value
  }
}

export const getStringValue = (defaultValue: string, currentValue?: string): string => {
  return currentValue || defaultValue
}

export const submitNumeric = (value: number | null, precision?: number, type?: NumericType): number => {
  const returnValue = value ?? 0
  if (type === 'cents') {
    return Math.round(returnValue * 100)
  }
  if (type === 'percentage') {
    return roundToPrecision(returnValue / 100, 4)
  }
  return roundToPrecision(returnValue, precision ?? 0)
}

export const submitString = (value: string) => value.trim()

export const getAdjustedDefaultValue = (defaultValue: number, type?: NumericType): number => {
  switch (type) {
    case 'cents': return defaultValue / 100
    case 'percentage': return defaultValue * 100
    default: return defaultValue
  }
}

export const formatDefaultValue = (defaultValue: number, precision?: number, type?: NumericType): string => {
  const adjustedDefaultValue = getAdjustedDefaultValue(defaultValue, type);
  if (type === 'cents') {
    return `$${adjustedDefaultValue.toFixed(2)}`
  }
  if (type === 'percentage') {
    return `${adjustedDefaultValue.toFixed(2)}%`
  }
  return adjustedDefaultValue.toFixed(precision ?? 0)
}

export const shouldShowNumericReset = (value: number | null, defaultValue: number, type?: NumericType): boolean => {
  return value !== getAdjustedDefaultValue(defaultValue, type)
}

export const shouldShowStringReset = (defaultValue: string, value?: string): boolean => {
  return value?.trim() !== defaultValue
}
